import React, { useEffect, useRef, useState, useContext } from "react";
import "./Footer.css";
import { Link, useLoaderData, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Button, Container, InputGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Common_Button from "../Common-Component/Common_Button/Common_Button";
import { SocialMedia } from "../../utils/apis/master/Master";
import { Context } from "../../utils/context";
import { occasion } from "../../utils/apis/Home/Homeapi";

import { useForm } from "react-hook-form";
import { Subscriber } from "../../utils/apis/form/form";
import classNames from "classnames";
import SuccessfullyModal from "../Common-Component/Commonmodal/SuccessfullyModal/SuccessfullyModal";
import { useNavigate } from "react-router-dom";
import { RegxExpression } from "../../utils/common";
const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState();
  const { IMG_URL, signin } = useContext(Context);
  const [showSuccess, setShowsuccess] = useState(false);
  const getAllData = async () => {
    const res = await SocialMedia();
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    getAllData();
  }, []);

  const [occasionprod, setOcassionprod] = useState([]);

  const getOcassion = async () => {
    const res = await occasion();
    if (res?.success) {
      setOcassionprod(res?.data);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // For smooth scrolling
    });
  };

  useEffect(() => {
    getOcassion();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    const res = await Subscriber(data);
    if (res?.success) {
      setShowsuccess(true);
      setTimeout(() => {
        reset();
        setShowsuccess(false);
      }, 2000);
    } else {
      if (res?.message?.email) {
        setError("email", { message: res?.message?.email });
      }
    }
  };

  return (
    <>
      <section className="footer">
        <div className="custom_container">
          <Row>
            <div className="col-lg-3 col-md-4 col-sm-6 col-6">
              <div className="Heading-holder">
                <h2 className="footer-title">THE COMPANY</h2>

                <Link onClick={scrollToTop} to={"/aboutUs"}>
                  <p
                    className={
                      location.pathname === "/aboutUs"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    ABOUT US
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/relevantNews"}>
                  <p
                    className={
                      location.pathname === "/relevantNews"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    LATEST NEWS
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/legalNotice"}>
                  <p
                    className={
                      location.pathname === "/legalNotice"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    LEGAL NOTICE
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/privacypolicy"}>
                  <p
                    className={
                      location.pathname === "/privacypolicy"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    PRIVACY POLICY
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/responsibility"}>
                  <p
                    className={
                      location.pathname === "/responsibility"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    RESPONSIBILITY
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/careers"}>
                  <p
                    className={
                      location.pathname === "/careers"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    {" "}
                    CAREERS @ MITTAL CRAFTWORKS{" "}
                  </p>
                </Link>

                {/* <Link onClick={scrollToTop} to={"/pageNotfound"}>
                  <p className={location.pathname === "/pageNotfound" ? "addfooterline" : "removefooterline"}> CAREERS @ MITTAL</p>
                </Link> */}
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-6">
              <div className="Heading-holder">
                <h2 className="footer-title">OFFERINGS</h2>

                <Link onClick={scrollToTop} to={"/all-category"}>
                  <p
                    className={
                      location.pathname === "/customizable-product"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    PRODUCTS
                  </p>
                </Link>

                {/* <p>GIFT BY PRICE</p> */}
                <Link onClick={scrollToTop} to={"/customizable-product"}>
                  <p
                    className={
                      location.pathname === "/customizable-product"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    GIFT BY PRICE
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/gift-automation"}>
                  <p
                    className={
                      location.pathname === "/gift-automation"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    GIFT AUTOMATION
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/sustainable-product"}>
                  <p
                    className={
                      location.pathname === "/sustainable-product"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    SUSTAINABLE GIFTS
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/gift-customization"}>
                  <p
                    className={
                      location.pathname === "/gift-customization"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    GIFT CUSTOMISATION
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/multi-recipient"}>
                  <p
                    className={
                      location.pathname === "/multi-recipient"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    MULTI-RECIPIENT SENDING
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/shopbyoccasion"}>
                  <p
                    className={
                      location.pathname === "/shopbyoccasion"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    GIFT BY OCCASIONS / EVENTS
                  </p>
                </Link>

                {/* <Link onClick={scrollToTop} to={"/sustainable-product"}>
                  <p className={location.pathname === "/sustainable-product" ? "addfooterline" : "removefooterline"}>SUSTAINABLE GIFTS</p>
                </Link> */}

                {/* */}

                {/* <p>GIFT BY OCCASIONS / EVENTS</p> */}
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-6">
              <div className="Heading-holder">
                <h2 className="footer-title">POPULAR LINKS</h2>
                <Link onClick={scrollToTop} to={"/blogs"}>
                  <p
                    className={
                      location.pathname === "/blogs"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    BLOGS
                  </p>
                </Link>

                {/* {occasionprod?.map((item) => */}
                {occasionprod?.slice(0, 5).map((item) => (
                  <Link onClick={scrollToTop} to={`/product/${item?.id}`}>
                    <p
                      className={
                        location.pathname === "/festivegifts"
                          ? "addfooterline"
                          : "removefooterline"
                      }
                    >
                      {item?.name}
                    </p>
                  </Link>
                ))}
                {/* <Link onClick={scrollToTop} to={"/festivegifts"}>
                  <p className={location.pathname === "/festivegifts" ? "addfooterline" : "removefooterline"}>⁠RETIREMENT GIFTS</p>

                </Link>

                <Link onClick={scrollToTop} to={"/festivegifts"}>
                  <p className={location.pathname === "/festivegifts" ? "addfooterline" : "removefooterline"}>EMPLOYEE WELCOME KITS</p>
                </Link>

                <Link onClick={scrollToTop} to={"/festivegifts"}>
                  <p className={location.pathname === "/festivegifts" ? "addfooterline" : "removefooterline"}>EMPLOYEE BIRTHDAY GIFTS</p>
                </Link>
                <Link onClick={scrollToTop} to={"/emp-satifaction"}>
                  <p className={location.pathname === "/emp-satifaction" ? "addfooterline" : "removefooterline"}>EMPLOYEE APPRECIATION GIFTS</p>

                </Link> */}
              </div>
            </div>
            <div className="col-lg-3 col-md-5 col-sm-6 col-6">
              <div className="Heading-holder">
                <h2 className="footer-title">SUPPORT</h2>

                <Link onClick={scrollToTop} to={"/faq"}>
                  <p
                    className={
                      location.pathname === "/faq"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    FAQ<span>s</span>
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/contactus"}>
                  <p
                    className={
                      location.pathname === "/contactus"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    CONTACT US
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/product-care"}>
                  <p
                    className={
                      location.pathname === "/product-care"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    PRODUCT CARE
                  </p>
                </Link>

                <p></p>

                <Link onClick={scrollToTop} to={"/made-to-order"}>
                  <p
                    className={
                      location.pathname === "/made-to-order"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    MADE TO ORDER
                  </p>
                </Link>
                {/* <p>UNSUBSCRIBE</p> */}

                <Link onClick={scrollToTop} to={"/request-quotation"}>
                  <p
                    className={
                      location.pathname === "/request-quotation"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    ⁠SUBMIT YOUR RFQ
                  </p>
                </Link>

                {signin ? (
                  <>
                    <Link onClick={scrollToTop} to={"/order-tracking"}>
                      <p
                        className={
                          location.pathname === "/order-tracking"
                            ? "addfooterline"
                            : "removefooterline"
                        }
                      >
                        ⁠TRACK YOUR ORDER
                      </p>
                    </Link>
                  </>
                ) : (
                  <></>
                )}

                <Link onClick={scrollToTop} to={"/gift-customization"}>
                  <p
                    className={
                      location.pathname === "/gift-customization"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    CUSTOMISE WITH US
                  </p>
                </Link>

                <Link onClick={scrollToTop} to={"/submitsuggestion"}>
                  <p
                    className={
                      location.pathname === "/submitsuggestion"
                        ? "addfooterline"
                        : "removefooterline"
                    }
                  >
                    ⁠SUBMIT YOUR SUGGESTIONS
                  </p>
                </Link>
              </div>
            </div>
            <div className="col-lg-5 col-md-5">
              <div className="social-link mt-3">
                <h2 className="footer-title mb-4">FOLLOW US</h2>
                <div className="social-linksss d-flex">
                  {data?.map((val) => (
                    <div className="social-icon text-center">
                      <a
                        href={val?.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="x-logo"
                          src={`${IMG_URL}${val?.image}`}
                          alt="Logo"
                        />
                      </a>
                    </div>
                  ))}
                  {/* <div className="social-icon text-center">
                    <FontAwesomeIcon icon={faLinkedin} className="fa-logo" />

                  </div> */}
                  {/* <div className="social-icon text-center">
                    <img className="x-logo" src={process.env.PUBLIC_URL + '/assest/image/logo/x-mark.png'} alt="Logo" />

                  </div> */}
                  {/* <div className="social-icon text-center">
                    <FontAwesomeIcon icon={faFacebookF} className="fa-logo" />
                  </div> */}
                  {/* <div className="social-icon text-center">
                   
                    <FontAwesomeIcon icon={faInstagram} className="fa-logo" />
                  </div> */}
                  {/* <div className="social-icon text-center">
                    <FontAwesomeIcon icon={faYoutube} className="fa-logo" />
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-9">
              <div className="news-letter-box mt-3">
                <h2 className="footer-title mb-4">NEWSLETTER</h2>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <InputGroup className="mb-3">
                    {/* <Form.Control
                    placeholder="Enter Email Address"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"

                  /> */}
                    <Form.Control
                      type="text"
                      name="email"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      placeholder="Enter Email Address"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: RegxExpression.email,
                          message: "Invalid email address",
                        },
                      })}
                      // className={classNames("", {
                      //   "is-invalid": errors?.email,
                      //   "is-valid": getValues("email"),
                      // })}
                    />

                    <InputGroup.Text id="basic-addon2">
                      {/* <Common_Button
                        text="Subscribe"
                        className="subscribe-btn"
                        type="submit"
                      /> */}
                      <Button
                        text="Subscribe"
                        className="subscribe-btn"
                        type="submit"
                      >
                        Subscribe
                      </Button>
                    </InputGroup.Text>
                  </InputGroup>
                  {errors?.email && (
                    <sup className="text-danger">{errors?.email?.message}</sup>
                  )}
                </Form>
              </div>
            </div>
            <div className="col-md-12 mobcenttt">
              <div className="copyright-holder  text-center">
                <p className="para1">
                  Copyright © {currentYear} Mittal Craftworks.
                </p>
                <p className="para2">
                  {" "}
                  All rights reserved. Use of this website indicates your
                  compliance with our{" "}
                  <span onClick={() => navigate("/privacypolicy")}>
                    {" "}
                    <b>Privacy Policy</b>{" "}
                  </span>{" "}
                  , Conditions of Carriage,
                  <span onClick={() => navigate("/terms-condition")}>
                    {" "}
                    <b>Terms and Conditions</b>
                  </span>{" "}
                  .
                </p>
              </div>
            </div>
          </Row>
        </div>
      </section>
      <SuccessfullyModal
        show={showSuccess}
        onHide={() => setShowsuccess(false)}
        text={"Subscribe successfully"}
      />
    </>
  );
};

export default Footer;
